import { View, Text, Pressable } from "react-native";
import { BookOpen, ChevronRight } from "lucide-react-native";
import { SectionTitle } from "@louise/moon-ui";
import { GLASS_CARD_STYLE } from "@louise/moon-ui/theme/tokens";
import {
  pressLabel,
  usePressCapture,
} from "@src/packages/analytics/usePressCapture";
import { EMBER } from "../../../onboarding/theme";
import { GLOSSARY_TERMS } from "./glossary.data";

type Props = {
  onPress: () => void;
};

export default function InsuranceGlossaryCard({ onPress }: Props) {
  const capturePress = usePressCapture("InsuranceGlossaryCard");
  return (
    <View>
      <View style={{ marginBottom: 12, paddingHorizontal: 2 }}>
        <SectionTitle icon={BookOpen}>Learn the lingo</SectionTitle>
      </View>

      <Pressable
        onPress={() => {
          capturePress(pressLabel("Insurance glossary"));
          onPress();
        }}
        style={{
          ...(GLASS_CARD_STYLE as object),
          padding: 18,
          flexDirection: "row",
          alignItems: "center",
          gap: 14,
        }}
      >
        <BookOpen size={22} color={EMBER.colors.text} strokeWidth={1.5} />
        <View style={{ flex: 1, gap: 2 }}>
          <Text
            className="font-dm-sans"
            style={{
              fontSize: 16,
              fontWeight: "600",
              color: EMBER.colors.text,
            }}
          >
            Insurance glossary
          </Text>
          <Text
            className="font-dm-sans"
            style={{
              fontSize: 13,
              color: EMBER.colors.textLight,
              lineHeight: 18,
            }}
          >
            {GLOSSARY_TERMS.length} terms · deductible, EOB, coinsurance, and
            more
          </Text>
        </View>
        <ChevronRight
          size={16}
          color={EMBER.colors.textFaint}
          strokeWidth={1.5}
        />
      </Pressable>
    </View>
  );
}
